<template>
  <Teleport to="body">
    <div
      class="page-curtain"
      :class="{
        'page-curtain--covering': phase === 'covering',
        'page-curtain--covered': phase === 'covered',
        'page-curtain--revealing': phase === 'revealing',
        'page-curtain--idle': phase === 'idle'
      }"
      aria-hidden="true"
    ></div>
  </Teleport>
</template>

<script setup>
import { pageCurtainPhase as phase } from '@/composables/usePageTransition'
</script>

<style scoped>
/* Pantalla negra a pantalla completa que sube al cambiar de página y al abrir
   el menú. En reposo queda fuera de la vista y no intercepta clicks. */
.page-curtain {
  position: fixed;
  inset: 0;
  z-index: 10001; /* debajo de la verificación de edad (10002), encima de todo lo demás */
  background: #000;
  transform: translate3d(0, 100%, 0);
  pointer-events: none;
  transition: transform var(--curtain-tapa, 420ms) cubic-bezier(0.65, 0, 0.35, 1);
  will-change: transform;
}

/* Subiendo hasta tapar */
.page-curtain--covering {
  transform: translate3d(0, 0, 0);
  pointer-events: auto;
}

/* Tapa completa: acá la página nueva se lleva al tope con scroll suave */
.page-curtain--covered {
  transform: translate3d(0, 0, 0);
  pointer-events: auto;
  transition-duration: 0ms;
}

/* Revelado: la cortina ya no sube más. Se queda tapando como fondo negro, pero
   pasa por detrás para que el contenido aparezca dentro del recuadro que sube
   hasta el tope (lo anima cada consumidor: la página o el menú). */
.page-curtain--revealing {
  transform: translate3d(0, 0, 0);
  z-index: -1;
  pointer-events: none;
  transition: none;
}

/* Reposo: vuelve abajo sin animar y deja de ser fondo */
.page-curtain--idle {
  transform: translate3d(0, 100%, 0);
  z-index: 10001;
  transition: none;
}

@media (prefers-reduced-motion: reduce) {
  .page-curtain {
    transition: none;
  }
}
</style>
